import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/home', redirect: '/login' },
  // {
  //   path: '/home',
  //   name: 'home',
  //   component: () => import('@/views/HomeView.vue')
  // },
  // {
  //   path: '/about',
  //   name: 'about',
  //   component: () => import('@/views/AboutView.vue')
  // },
  // {
  //   path: '/contact-us',
  //   name: 'contact-us',
  //   component: () => import('@/views/ContactView.vue')
  // },
  {
    path: '/login',
    name: 'login',
    meta: { layout: "blank" },
    component: () => import('@/views/LoginPage.vue')
  },
  {
    path: '/event/booking',
    name: 'Event Booking',
    component: () => import('@/views/pages/event/EventBooking.vue')
  },
  {
    path: '/order/success',
    name: 'Order Success',
    component: () => import('@/views/pages/event/PaymentSuccess.vue')
  },

  {
    path: '/judges/list',
    name: 'Judges List',
    component: () => import('@/views/pages/judges/JudgesList.vue')
  },
  {
    path: '/judges/upload',
    name: 'Judges Upload',
    component: () => import('@/views/pages/judges/JudgesUpload.vue')
  },
  {
    path: '/awards-mapping/not-mapped',
    name: 'Not Mapped Awards',
    component: () => import('@/views/pages/awards-mapping/not-mapped/NotMappedAwardsList.vue')
  },
  {
    path: '/awards-mapping/mapped-by-awards',
    name: 'Mapped By Awards',
    component: () => import('@/views/pages/awards-mapping/mapped-by-awards/MappedByAwardsList.vue')
  }, {
    path: '/awards-mapping/mapped-by-judges',
    name: 'Mapped By Judges',
    component: () => import('@/views/pages/awards-mapping/mapped-by-judges/MappedByJudgesList.vue')
  },
  {
    path: '/awards/list',
    name: 'Awards List',
    component: () => import('@/views/pages/awards/AwardsList.vue')
  },
  {
    path: '/awards/edit',
    name: 'Awards Scoring',
    component: () => import('@/views/pages/awards/AwardsEdit.vue')
  },
  {
    path: '/individual-awards/list',
    name: 'Group I - Individual Awards List',
    component: () => import('@/views/pages/awards/IndividualAwardsList.vue')
  },
  {
    path: '/lo-awards/list',
    name: 'Group II - LO Awards List',
    component: () => import('@/views/pages/awards/LoAwardsList.vue')
  },
  {
    path: '/officers-awards/list',
    name: 'Group III A - Officers Awards List',
    component: () => import('@/views/pages/awards/OfficersAwardsList.vue')
  },
  {
    path: '/vice-president-awards/list',
    name: 'Group III B - Vice President Awards List',
    component: () => import('@/views/pages/awards/VicePresidentAwardsList.vue')
  },
  {
    path: '/zone-directory-information/list',
    name: 'zone Directory Information',
    component: () => import('@/views/pages/zone-directory-information/ZoneDirectoryInformationList.vue')
  },

]

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    console.log({ to });
    console.log({ from });
    console.log({ savedPosition });
    return { x: 0, y: 0 }
  }
});

router.beforeEach(async (to, from, next) => {
  var ToName = to.name;
  if (ToName) {
    // showLoader();
  }

  var fromPath = from.path;
  var toPath = to.path;
  console.log("navigation from=" + fromPath + ", to=" + toPath);
  // var server_url = companyConfig.apiURL;
  // console.log({ server_url });

  var token = localStorage.getItem("token");
  token = token == (null || undefined) ? "" : token;
  console.log({ token });

  if (
    to.path == "/" ||
    to.path == "/login" ||
    to.path == "/register" ||
    to.path == "/verify-otp" ||
    to.path == "/forgot-password" ||
    to.path == "/pages/error-404" ||
    to.path == "/pages/error-500" ||
    to.path == "/pages/register" ||
    to.path == "/callback" ||
    to.path == "/pages/not-authorized" ||
    to.path == "/pages/comingsoon"
  ) {
    console.log("navigation true");
    next();
  } else {
    console.log("navigation false");
    if (token != "") {
      console.log("token is valid");
      next();
    } else {
      console.log("session is expired");
      router.push("/login");
    }
  }
});
export default router
